import {useTheme} from '@mui/material';
import Button from '@mui/material/Button';
import {capitalizeWords} from '../../utils';
import CircularProgress from '@mui/material/CircularProgress';
import {SD_BUTTON_RADIUS} from '../../constants/ui-tokens';

const CustomButton = ({ onClick = () => { }, visible = true, text, variant = 'contained', color = 'secondary', disabled = false, type, disablePadding, loading = false, borderRadius = SD_BUTTON_RADIUS, backgroundColor = '#02140A', textColor = '#fff', hoverColor = '#021209', width = null, height = '40px', selected = false, marginBlock = null, fontWeight = 600, textTransform = null }) => {
  const theme = useTheme();
  return (
    <Button
      sx={{
        fontWeight: fontWeight,
        visibility: visible ? 'visible' : 'hidden',
        borderRadius: borderRadius,
        backgroundColor: selected ? '#ffffff' : (type === 'outlined' ? 'transparent' : backgroundColor),
        color: selected ? '#000000' : textColor,
        ...(textTransform && {
          textTransform: textTransform
        }),
        ...(width && {
          width: width
        }),
        ...(height && {
          '&&': {
            height,
            minHeight: height,
          },
          padding: disablePadding ? 0 : '0 16px',
          lineHeight: 1.2,
        }),
        border: selected ? '2px solid #000000' : (type === 'outlined' ? `1px solid ${textColor}` : 'none'),
        '&:hover': {
          backgroundColor: selected ? '#ffffff' : hoverColor,
          ...(type === 'outlined' && !selected && {backgroundColor: '#f5f5f5'})
        }
      }}
      type={type === 'submit' ? 'submit' : 'button'}
      style={{
        marginBlock: marginBlock !== null
          ? marginBlock
          : disablePadding
            ? theme.spacing(0)
            : theme.spacing(2)
      }}
      variant={variant}
      color={color}
      onClick={onClick}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={20} sx={{ color: '#ffffff' }} /> : null}
    >
      {loading ? '' : capitalizeWords(text)}
    </Button>
  );
};

export default CustomButton;
